export default __webpack_public_path__ + "static/media/instruc_1.74767b79.png";